function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 187 187",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4868,-13264)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1184.19,3228.11L1193.44,3228.11L1193.44,3213.37C1193.44,3209.49 1194.18,3205.72 1198.99,3205.72C1203.74,3205.72 1203.81,3210.17 1203.81,3213.63L1203.81,3228.11L1213.06,3228.11L1213.06,3211.77C1213.06,3203.75 1211.33,3197.58 1201.96,3197.58C1197.45,3197.58 1194.43,3200.05 1193.2,3202.39L1193.07,3202.39L1193.07,3198.32L1184.19,3198.32L1184.19,3228.11ZM1173.75,3183.51C1176.71,3183.51 1179.12,3185.91 1179.12,3188.87C1179.12,3191.84 1176.71,3194.25 1173.75,3194.25C1170.78,3194.25 1168.38,3191.84 1168.38,3188.87C1168.38,3185.91 1170.78,3183.51 1173.75,3183.51ZM1169.11,3198.32L1178.38,3198.32L1178.38,3228.11L1169.11,3228.11L1169.11,3198.32Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.087830de2196e4e684c433189c0be29a.svg";
export { ForwardRef as ReactComponent };